export default {"src":"/_next/static/media/integration-ux-ui-scenarios-bg.11fa7c45.svg","height":280,"width":280,"blurWidth":0,"blurHeight":0};